import * as TYPES from './type';
export default {
  //授课首页
  [TYPES.SK_COURSE_LIST](state, { result }) {
    state.SKcourseList = result.result
  },
  //打开手写板
  [TYPES.SK_OPEN_PAD](state, { result }) {
    state.SKopenpad = result.result
  },
  //获取评分类型
  [TYPES.SK_EVALUATE_TYPE](state, { result }) {
    state.SKevaluateType = result.result
  },
  //添加教室
  [TYPES.SK_ADD_CLASSROOM](state, { result }) {
    state.AddClassRoom = result.result
  },
}